"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = __importStar(require("styled-components"));
var react_router_dom_2 = require("react-router-dom");
var ListItem = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var Button = styled_components_1.default(react_router_dom_2.Link)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-decoration: none;\n  outline: none;\n  cursor: pointer;\n  border-radius: 5px;\n  border: none;\n  background: transparent;\n  margin: 20px 10px;\n  color: #000;\n  font-size: 22px;\n  text-transform: uppercase;\n  font-weight: 800;\n  padding: 10px 20px;\n  transition: all 0.3s ease;\n\n  ", "\n\n  &:hover {\n    transform: scale(1.1);\n  }\n"], ["\n  text-decoration: none;\n  outline: none;\n  cursor: pointer;\n  border-radius: 5px;\n  border: none;\n  background: transparent;\n  margin: 20px 10px;\n  color: #000;\n  font-size: 22px;\n  text-transform: uppercase;\n  font-weight: 800;\n  padding: 10px 20px;\n  transition: all 0.3s ease;\n\n  ",
    "\n\n  &:hover {\n    transform: scale(1.1);\n  }\n"])), function (_a) {
    var selected = _a.selected;
    return selected && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background: #fff;\n    "], ["\n      background: #fff;\n    "])));
});
var Item = function (_a) {
    var children = _a.children, path = _a.path;
    var match = Boolean(react_router_dom_1.useRouteMatch({
        path: path,
        exact: true
    }));
    return (react_1.default.createElement(ListItem, null,
        react_1.default.createElement(Button, { to: path, selected: match }, children)));
};
exports.default = Item;
var templateObject_1, templateObject_2, templateObject_3;
